import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import ENUMS from '../../enums/index';
import { enumHelper } from '../../utils';
import * as reserveActions from '../../redux/reservations/actions';

import Spin from '../../components/loading';

const CheckoutDetails = props => {
  let {
    id,
    cafeId,
    cafeName,
    createdAt,
    fromDate,
    toDate,
    reservesCount,
    amount,
    auditorId,
    auditor,
    status,
    currency,
    reserves = [],
    isCheckout,
    payType,
    paidAt,
    payerName,
    sourceBankName,
    destinationBankName
  } = props.checkoutDetails;

  let {
    checkoutDetailsLoading,
    checkoutDetailsError,
    checkoutDetailsFailed,
    checkoutDetailsMessage
  } = props;

  useEffect(() => {
    props.fetchCheckoutReserveDetails(props.checkoutId);
  }, []);
  return (
    <>
      <Modal id="financial-transaction-modal" size="xl" isOpen={props.isOpen}>
        <ModalHeader>
          <div className="row">
            <div className="col-11">{locales('tables.checkoutDetails')}</div>
            <div className="col-1 text-left">
              <a
                href="#"
                className=""
                onClick={event => {
                  event.preventDefault();
                  props.closeModal();
                }}
              >
                <i className="fas fa-times"></i>
              </a>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <Spin spinning={checkoutDetailsLoading}>
            <article>
              {checkoutDetailsError ? (
                <div className="alert alert-danger">{locales('messages.server.error')}</div>
              ) : (
                <>
                  {checkoutDetailsFailed && (
                    <div className="alert alert-danger">{checkoutDetailsMessage}</div>
                  )}
                  <article className="col-12">
                    <div className="col-12 p-0 py-1 font-weight-bold text-dark">
                      {locales('titles.basicInfo')}
                    </div>
                    <div className="col-12 d-flex border rounded py-2 px-1 flex-wrap">
                      <div className="col-6 d-flex align-items-center">
                        <div className="col-5 text-muted">{locales('fields.cafe.name')} : </div>
                        <div className="col-7 text-dark font-weight-bold font-large">{cafeName}</div>
                      </div>
                      <div className="col-6 d-flex justify-content-end align-items-center p-0"></div>

                      <div className="col-6 d-flex align-items-center">
                        <div className="col-5 text-muted">{locales('tables.count')} : </div>
                        <div className="col-7 text-dark font-weight-bold font-large">
                          {reservesCount || '---'}
                        </div>
                      </div>
                      <div className="col-6 d-flex justify-content-end align-items-center p-0">
                        <div className="col-5 text-muted text-left">{locales('fields.requestTime')} : </div>
                        <div className="col-7 text-left text-dark font-weight-bold font-large">
                          {createdAt}
                        </div>
                      </div>

                      <div className="col-6 d-flex align-items-center">
                        <div className="col-5 text-muted">{locales('titles.fromTime')} : </div>
                        <div className="col-7 text-dark font-weight-bold font-large">{fromDate || '---'}</div>
                      </div>
                      <div className="col-6 d-flex justify-content-end align-items-center p-0">
                        <div className="col-5 text-muted text-left">{locales('labels.to.date')} : </div>
                        <div className="col-7 text-left text-dark font-weight-bold font-large">{toDate}</div>
                      </div>

                      <div className="col-6 d-flex align-items-center">
                        <div className="col-5 text-muted">{locales('tables.auditor')} : </div>
                        <div className="col-7 text-dark font-weight-bold font-large">{auditor || '---'}</div>
                      </div>
                      <div className="col-6 d-flex justify-content-end align-items-center p-0">
                        <div className="col-5 text-muted text-left">{locales('tables.payStatus')} : </div>
                        <div className="col-7 text-left text-dark font-weight-bold font-large">{status}</div>
                      </div>
                    </div>

                    {isCheckout && (
                      <div className="my-4">
                        <div className="col-12 p-0 py-1 font-weight-bold text-dark">
                          {locales('titles.checkout')}
                        </div>
                        <div className="col-12 d-flex border rounded py-2 px-1 flex-wrap">
                          <div className="col-6 d-flex align-items-center">
                            <div className="col-5 text-muted">{locales('fields.checkout.payerName')} : </div>
                            <div className="col-7 text-dark font-weight-bold font-large">
                              {payerName || '---'}
                            </div>
                          </div>
                          <div className="col-6 d-flex align-items-center"></div>

                          <div className="col-6 d-flex align-items-center">
                            <div className="col-5 text-muted">{locales('fields.checkout.payType')} : </div>
                            <div className="col-7 text-dark font-weight-bold font-large">
                              {enumHelper.convertEnumValueToTitle(ENUMS.PAY_TYPES.list, payType) || '---'}
                            </div>
                          </div>
                          <div className="col-6 d-flex justify-content-end align-items-center p-0">
                            <div className="col-5 text-muted text-left">
                              {locales('fields.checkout.paidAt')} :{' '}
                            </div>
                            <div className="col-7 text-left text-dark font-weight-bold font-large">
                              {paidAt}
                            </div>
                          </div>

                          <div className="col-6 d-flex align-items-center">
                            <div className="col-5 text-muted">
                              {locales('fields.checkout.sourceBankName')} :{' '}
                            </div>
                            <div className="col-7 text-dark font-weight-bold font-large">
                              {sourceBankName}
                            </div>
                          </div>

                          <div className="col-6 d-flex justify-content-end align-items-center p-0">
                            <div className="col-5 text-muted text-left">
                              {locales('fields.checkout.destinationBankName')} :{' '}
                            </div>
                            <div className="col-7 text-left text-dark font-weight-bold font-large">
                              {destinationBankName || '---'}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="my-4">
                      <div className="col-12 p-0 py-1 font-weight-bold text-dark">
                        {locales('titles.reserves')}
                      </div>
                      <div className="border rounded p-2">
                        {reserves &&
                          reserves.length &&
                          reserves.map((item, index) => (
                            <div
                              key={item.id}
                              className={`col-12 d-flex ${
                                reserves.length === index + 1 ? '' : 'border-bottom'
                              } py-2 px-1 flex-wrap`}
                            >
                              <div className="col-6 d-flex align-items-center">
                                <div className="col-5 text-muted">{locales('tables.mealPortions')} : </div>
                                <div className="col-7 text-dark font-weight-bold font-large">
                                  {enumHelper.convertEnumValueToTitle(ENUMS.MEAL_PORTIONS.list, item.meal) ||
                                    '---'}
                                </div>
                              </div>
                              <div className="col-6 d-flex justify-content-end align-items-center p-0">
                                <div className="col-5 text-muted text-left">{locales('tables.date')} : </div>
                                <div className="col-7 text-left text-dark font-weight-bold font-large">
                                  {item.date}
                                </div>
                              </div>

                              <div className="col-6 d-flex align-items-center">
                                <div className="col-5 text-muted">{locales('titles.fromTime')} : </div>
                                <div className="col-7 text-dark font-weight-bold font-large">
                                  {item.startAt || '---'}
                                </div>
                              </div>
                              <div className="col-6 d-flex justify-content-end align-items-center p-0">
                                <div className="col-5 text-muted text-left">
                                  {locales('labels.to.date')} :{' '}
                                </div>
                                <div className="col-7 text-left text-dark font-weight-bold font-large">
                                  {item.endAt}
                                </div>
                              </div>

                              <div className="col-6 d-flex align-items-center">
                                <div className="col-5 text-muted">{locales('fields.trackingNumber')} : </div>
                                <div className="col-7 text-dark font-weight-bold font-large direction-ltr">
                                  {item.trackingNumber || '---'}
                                </div>
                              </div>
                              <div className="col-6 d-flex justify-content-end align-items-center p-0">
                                <div className="col-5 text-muted text-left">
                                  {locales('tables.peopleCount')} :{' '}
                                </div>
                                <div className="col-7 text-left text-dark font-weight-bold font-large">
                                  {item.people}
                                </div>
                              </div>

                              <div className="col-6 d-flex align-items-center">
                                <div className="col-5 text-muted">{locales('fields.rsee.amount')} : </div>
                                <div className="col-7 text-dark font-weight-bold font-large">
                                  {item.rseeContributionAmount || '---'}
                                </div>
                              </div>
                              <div className="col-6 d-flex justify-content-end align-items-center p-0">
                                <div className="col-5 text-muted text-left">
                                  {locales('tables.prePaid')} :{' '}
                                </div>
                                <div className="col-7 text-left text-dark font-weight-bold font-large">
                                  {item.baseCost}
                                </div>
                              </div>

                              <div className="col-6 d-flex align-items-center">
                                <div className="col-5 text-muted">{locales('tables.status')} : </div>
                                <div className="col-7 text-dark font-weight-bold font-large">
                                  {enumHelper.convertEnumValueToTitle(
                                    ENUMS.CAFE_RESERVATION.list,
                                    item.status
                                  ) || '---'}
                                </div>
                              </div>
                              <div className="col-6 d-flex justify-content-end align-items-center p-0">
                                <div className="col-5 text-muted text-left">
                                  {locales('tables.totalPrice')} :{' '}
                                </div>
                                <div className="col-7 text-left text-dark font-weight-bold font-large">
                                  {item.totalPrice}
                                </div>
                              </div>

                              <div className="col-6 d-flex align-items-center">
                                <div className="col-5 text-muted">{locales('tables.balance')} : </div>
                                <div className="col-7 text-dark font-weight-bold font-large">
                                  {item.balance || '---'}
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </article>
                </>
              )}
            </article>
          </Spin>
        </ModalBody>
        <ModalFooter>
          <div className="col-4 d-flex justify-content-end align-items-center">
            <button className="btn btn-default mx-1" onClick={() => props.closeModal()}>
              {locales('tables.close')}
            </button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

const mapStateToProps = state => {
  return {
    checkoutDetails: state.reservationsReducer.checkoutDetails || {},
    checkoutDetailsLoading: state.reservationsReducer.checkoutDetailsLoading,
    checkoutDetailsMessage: state.reservationsReducer.checkoutDetailsMessage,
    checkoutDetailsFailed: state.reservationsReducer.checkoutDetailsFailed,
    checkoutDetailsError: state.reservationsReducer.checkoutDetailsError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchCheckoutReserveDetails: id => dispatch(reserveActions.fetchCheckoutReserveDetails(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckoutDetails);
